var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnalysisIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2706 15.8504C38.6393 15.8504 42.9916 20.1372 42.9916 25.4252C42.9916 30.7132 38.6393 35 33.2706 35C27.9019 35 23.5498 30.7132 23.5498 25.4252C23.5498 20.1371 27.9019 15.8504 33.2706 15.8504ZM31.9938 26.2697L29.8217 24.1303C29.2588 23.5758 28.3456 23.5758 27.7826 24.1303C27.2197 24.6847 27.2197 25.5842 27.7826 26.1386L30.9773 29.2853C31.5402 29.8398 32.4534 29.8398 33.0163 29.2853C34.9419 27.3887 36.8457 25.4706 38.7625 23.5652C39.3214 23.0097 39.3196 22.1131 38.7562 21.5612C38.1927 21.0092 37.28 21.0109 36.7204 21.5675L31.9938 26.2697ZM13.9922 0C17.9793 0 21.2115 3.18356 21.2115 7.11068C21.2115 11.0378 17.9793 14.2214 13.9922 14.2214C10.0051 14.2214 6.77298 11.0378 6.77298 7.11068C6.77298 3.18356 10.0051 0 13.9922 0ZM1.20096 27.9539L21.9144 27.9537C21.7285 27.1401 21.6298 26.2941 21.6298 25.4251C21.6298 23.0683 22.3522 20.8778 23.5901 19.056C21.0547 16.7868 17.6878 15.4033 13.9922 15.4033C7.1307 15.4033 1.40004 20.1707 0.0271384 26.5258C-0.1327 27.2653 0.433454 27.9539 1.20096 27.9539Z",
    fill: "#1E3A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnalysisIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/analysisIcon.0893041b147b010a2b3c225740500b62.svg";